import React from "react";

const BANNER_BASE =
  "pointer-events-auto w-fit min-w-0 max-w-[min(42rem,100%)] animate-notice-slide-in rounded-md border px-4 py-2.5 text-sm text-left shadow-md break-words";

const VARIANT_CLASS = {
  success: `${BANNER_BASE} border-green-200 bg-green-50 text-green-800`,
  error: `${BANNER_BASE} border-red-200 bg-red-50 text-red-800`,
  info: `${BANNER_BASE} border-blue-200 bg-blue-50 text-blue-800`,
};

/**
 * Fixed stack of success/error/info messages that slide in from the top (`animate-notice-slide-in` in Tailwind).
 * @param {{ key: string, variant: 'success'|'error'|'info', text: string }[]} items
 * @param {string} [wrapperClassName] — outer fixed container (position, z-index, horizontal inset)
 */
export default function TopSlideFlashNotices({ items = [], wrapperClassName }) {
  const list = items.filter((it) => it && it.text);
  if (list.length === 0) return null;

  return (
    <div
      className={wrapperClassName}
      aria-live="polite"
    >
      {list.map(({ key, variant, text }) => {
        const cls = VARIANT_CLASS[variant] || VARIANT_CLASS.error;
        const role = variant === "error" ? "alert" : "status";
        return (
          <div key={key} role={role} className={cls}>
            {text}
          </div>
        );
      })}
    </div>
  );
}
